<section
  class="container-fluid"
  style="background-color: white; min-height: 100%;"
>
  <div class="topbar d-flex justify-content-between mx-1">
    <button (click)="previousSection()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/94e4da27ba1b99b28b565c38ff7e7b86c50c863e69b6bac6710576d28b53d2bc?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
        alt="Profile"
        class="profile-icon"
      />
    </button>
    <button (click)="onBack()">
      <img
        src="https://cdn.builder.io/api/v1/image/assets/TEMP/7cb02f3bafac43cfab39d23a61c0455196795a73ffc77ad66c7f8968319328e1?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
        alt=""
        class="close-icon"
      />
    </button>
  </div>
  <form class="order-form" [formGroup]="orderForm">
    <section class="order-summary">
      <div class="text-left mb-3">
        <h2 class="ms-2 mb-2 fw-bold">Thông tin giao hàng</h2>
        <p class="ms-2 mb-0">Bạn vui lòng điền thông tin của bạn</p>
      </div>
      <section class="card">
        <header class="card-header">
          <img
            [src]="registrationData.product.src"
            [alt]="registrationData.product.name"
            class="product-image"
          />
          <div class="product-details">
            <div class="product-info">
              <h2 class="product-name">
                {{ registrationData.product.name === "wifi" ? "Loa Wifi" : "Loa
                4G" }}
              </h2>
              <span class="product-quantity mr-3"
                >x{{ registrationData.product.quantity }}</span
              >
            </div>
            <div class="product-pricing">
              <span class="service-period">
                Gói dịch vụ
                <strong class="highlight"
                  >{{ registrationData.package.original_duration }}
                  tháng</strong
                >
              </span>
              <span class="product-price"
                >{{ registrationData.package.discounted_price | number : "1.0-0"
                }} VND</span
              >
            </div>
          </div>
        </header>
        <hr class="divider" />
        <div class="summary-row">
          <span>Tiền hàng</span>
          <span
            >{{ registrationData.package.discounted_price *
            registrationData.product.quantity | number : "1.0-0" }} VND
          </span>
        </div>
        <div class="summary-row" *ngIf="serviceType === 'shipper'">
          <span>Phí giao hàng</span>
          <span>30,000 VND</span>
        </div>
        <hr class="divider solid" />
        <div class="summary-row total">
          <span>Thành tiền</span>
          <span class="highlight">
            {{ registrationData.package.discounted_price *
            registrationData.product.quantity + (serviceType === "shipper" ?
            30000 : 0) | number : "1.0-0" }}VND</span
          >
        </div>
      </section>
    </section>
    <section class="store-info">
      <h2 class="section-title">Thông tin cửa hàng</h2>
      <ng-container *ngIf="listDataWs.length > 0; else inputFields">
        <div class="input-group">
          <mat-form-field>
            <mat-label>Chọn cửa hàng</mat-label>
            <mat-select formControlName="selectedStore" required>
              <mat-option
                class="bg-primary text-white underline-option"
                data-bs-toggle="modal"
                data-bs-target="#modalAdd"
                [value]="0"
              >
                Thêm mới cửa hàng
              </mat-option>
              <mat-option *ngFor="let store of listDataWs" [value]="store.id">
                {{ store.code }} - {{ store.name }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
          orderForm.get('selectedStore').invalid &&
          (orderForm.get('selectedStore').touched || orderForm.get('selectedStore').dirty)
        "
            >
              Bạn phải chọn cửa hàng.
            </mat-error>
          </mat-form-field>
        </div>

        <div class="input-group">
          <mat-form-field>
            <mat-label>Thông tin tài khoản</mat-label>
            <input
              matInput
              readonly
              value=" {{ getSelectedStore().account_number }} - {{ getSelectedStore().bank_account_name }}"
            />
          </mat-form-field>
        </div>
      </ng-container>

      <ng-template #inputFields>
        <div class="input-group">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/b747068bdaff285b4c0b598eae2550df6ccb62a982e33f35b7eabcab01c462e7?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
            alt=""
            class="input-icon"
          />
          <mat-form-field>
            <mat-label>Tên cửa hàng</mat-label>
            <input matInput formControlName="storeName" required
            (input)="onInputChange($event, 'storeName')"
            />
            <mat-error
              *ngIf="
                orderForm.get('storeName').invalid &&
                (orderForm.get('storeName').touched ||
                  orderForm.get('storeName').dirty)
              "
            >
              Tên cửa hàng là bắt buộc.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="input-group">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/a24af1b7a5113f1d1d02150c4ec757a1d4892b18490fa41dad044b3bd0023a26?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
            alt=""
            class="input-icon"
          />
          <mat-form-field>
            <mat-label>Địa chỉ cửa hàng</mat-label>
            <input matInput formControlName="storeAddress" 
            (input)="onInputChange($event, 'storeAddress')"
            required />
            <mat-error
              *ngIf="
                orderForm.get('storeAddress').invalid &&
                (orderForm.get('storeAddress').touched ||
                  orderForm.get('storeAddress').dirty)
              "
            >
              Địa chỉ cửa hàng là bắt buộc.
            </mat-error>
          </mat-form-field>
        </div>
        <div class="input-group">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/8795d34e354a4ea4c2f1e673f1b6b70614e105214919bea0ffb38ff3145fb12c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
            alt=""
            class="input-icon"
          />
          <mat-form-field *ngIf="dataUser.length > 0; else inputTemplate">
            <mat-label>Số tài khoản QR</mat-label>
            <mat-select
              formControlName="qrAccount"
              (selectionChange)="onInputBlur()"
              required
            >
              <mat-option [value]="">
                Thêm mới tài khoản
              </mat-option>
              <mat-option
                *ngFor="let account of dataUser"
                [value]="account.account_number"
              >
                {{ account.account_number }}
              </mat-option>
            </mat-select>
            <mat-error
              *ngIf="
                orderForm.get('qrAccount').invalid &&
                (orderForm.get('qrAccount').touched ||
                  orderForm.get('qrAccount').dirty)
              "
            >
              Số tài khoản QR là bắt buộc.
            </mat-error>
          </mat-form-field>
          <ng-template #inputTemplate>
            <mat-form-field>
              <mat-label>Số tài khoản QR</mat-label>
              <input
                matInput
                formControlName="qrAccount"
                (blur)="onInputBlur()"
            (input)="onInputChange($event, 'qrAccount')"

                required
              />
              <mat-error
                *ngIf="
                  orderForm.get('qrAccount').invalid &&
                  (orderForm.get('qrAccount').touched ||
                    orderForm.get('qrAccount').dirty)
                "
              >
                Số tài khoản QR là bắt buộc.
              </mat-error>
            </mat-form-field>
          </ng-template>
        </div>
        <div class="input-group">
          <img
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
            alt=""
            class="input-icon"
          />
          <mat-form-field>
            <mat-label>Chủ tài khoản</mat-label>
            <input matInput formControlName="accountOwner" readonly required />
            <mat-error
              *ngIf="
                orderForm.get('accountOwner').invalid &&
                (orderForm.get('accountOwner').touched ||
                  orderForm.get('accountOwner').dirty)
              "
            >
              Chủ tài khoản là bắt buộc.
            </mat-error>
          </mat-form-field>
        </div>
      </ng-template>
    </section>

    <section class="recipient-info" *ngIf="serviceType === 'shipper'">
      <h2 class="section-title">Thông tin người nhận</h2>
      <div class="input-group">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
          alt=""
          class="input-icon"
        />
        <mat-form-field>
          <mat-label>Tên người nhận</mat-label>
          <input
            matInput
            formControlName="recipientName"
            (input)="onInputChange($event, 'recipientName')"
            required
          />
          <mat-error
            *ngIf="orderForm.get('recipientName').hasError('required')"
          >
            Tên người nhận là bắt buộc.
          </mat-error>
          <mat-error *ngIf="orderForm.get('recipientName').hasError('noIcons')">
            Tên người nhận không được chứa ký tự đặc biệt.
          </mat-error>
        </mat-form-field>
      </div>
      <div class="input-group">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/4961fecc01ee785d0bbf7d225ff229e29e5f7d0e204a74b9eb718efa0946f95d?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
          alt=""
          class="input-icon"
        />
        <mat-form-field>
          <mat-label>Số điện thoại</mat-label>
          <input
            matInput
            type="tel"
            formControlName="recipientPhone"
            (input)="onInputChange($event, 'recipientPhone')"

            required
          />
          <mat-error
            *ngIf="
              orderForm.get('recipientPhone').invalid &&
              (orderForm.get('recipientPhone').touched ||
                orderForm.get('recipientPhone').dirty)
            "
          >
            <ng-container
              *ngIf="orderForm.get('recipientPhone').hasError('required')"
            >
              Số điện thoại là bắt buộc.
            </ng-container>
            <ng-container
              *ngIf="orderForm.get('recipientPhone').hasError('pattern')"
            >
              Số điện thoại không hợp lệ.
            </ng-container>
            <ng-container
              *ngIf="orderForm.get('recipientPhone').hasError('minlength')"
            >
              Số điện thoại phải có ít nhất 10 số.
            </ng-container>
            <ng-container
              *ngIf="orderForm.get('recipientPhone').hasError('maxlength')"
            >
              Số điện thoại không được nhiều hơn 10 số.
            </ng-container>
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="shipping-address" *ngIf="serviceType === 'shipper'">
      <h2 class="section-title">Địa chỉ nhận hàng</h2>

      <div class="input-group">
        <mat-form-field>
          <mat-label>Tỉnh/thành phố</mat-label>
          <mat-select
            formControlName="province"
            (selectionChange)="onProvinceChange($event.value)"
            required
          >
            <mat-option
              *ngFor="let province of listProvince"
              [value]="province"
            >
              {{ province.PROVINCE_NAME }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              orderForm.get('province').invalid &&
              (orderForm.get('province').touched ||
                orderForm.get('province').dirty)
            "
          >
            Tỉnh/thành phố là bắt buộc.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-group">
        <mat-form-field>
          <mat-label>Quận/huyện</mat-label>
          <mat-select
            formControlName="district"
            (selectionChange)="onDistrictChange($event.value)"
            required
          >
            <mat-option
              *ngFor="let district of listDistrict"
              [value]="district"
            >
              {{ district.DISTRICT_NAME }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              orderForm.get('district').invalid &&
              (orderForm.get('district').touched ||
                orderForm.get('district').dirty)
            "
          >
            Quận/huyện là bắt buộc.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-group">
        <mat-form-field>
          <mat-label>Phường/xã</mat-label>
          <mat-select formControlName="ward" required>
            <mat-option *ngFor="let ward of listWard" [value]="ward">
              {{ ward.WARDS_NAME }}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="
              orderForm.get('ward').invalid &&
              (orderForm.get('ward').touched || orderForm.get('ward').dirty)
            "
          >
            Phường/xã là bắt buộc.
          </mat-error>
        </mat-form-field>
      </div>

      <div class="input-group">
        <img
          src="https://cdn.builder.io/api/v1/image/assets/TEMP/a24af1b7a5113f1d1d02150c4ec757a1d4892b18490fa41dad044b3bd0023a26?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
          alt=""
          class="input-icon"
        />
        <mat-form-field>
          <mat-label>Địa chỉ</mat-label>
          <input matInput formControlName="address" required
          (input)="onInputChange($event, 'address')"
          />
          <mat-error
            *ngIf="
              orderForm.get('address').invalid &&
              (orderForm.get('address').touched ||
                orderForm.get('address').dirty)
            "
          >
            Địa chỉ là bắt buộc.
          </mat-error>
        </mat-form-field>
      </div>
    </section>

    <section class="payment-confirmation mt-3 mb-5">
      <div class="terms-agreement">
        <input
          type="checkbox"
          id="termsCheckbox"
          checked
          (change)="onCheckboxChange($event)"
        />
        <label class="checkbox-label font-weight-normal">
          Tôi đã đọc và đồng ý với
          <span
            class="highlight-text"
            data-bs-toggle="modal"
            data-bs-target="#chooseConditions"
            >Điều khoản Dịch vụ & Chính sách Bảo hành</span
          >
        </label>
      </div>
      <button
        class="payment-button fixed-button"
        data-bs-toggle="modal"
        data-bs-target="#chooseModal"
        [disabled]="!orderForm.valid || !isTermsAgreed"
      >
        Thanh toán
      </button>
    </section>
  </form>
</section>


<div
  #chooseConditions
  class="modal fade bottom-modal mw-100"
  id="chooseConditions"
  tabindex="-1"
  aria-labelledby="chooseConditionsLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="modal-content" style="border-radius: 1rem;">
      <section class="delivery-modal">
        <header class="modal-header">
          <h2 class="modal-title">Điều khoản và điều kiện</h2>
          <button
            class="close-button"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/97a7253f394325dd307cb69b66b6c2a5d4f713d8a927da55219b908ade8639d6?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
              alt=""
              class="close-icon"
            />
          </button>
        </header>
        <main class="modal-content-2 pt-0 px-2 pb-0 border-0">
          <h4>ĐIỀU 1 - GIẢI THÍCH TỪ NGỮ</h4>
          <ol>
            <li>
              <strong>Đơn vị cung cấp dịch vụ:</strong> Là Công ty CP Tomotek
              (Tomotek).
            </li>
            <li>
              <strong>Khách hàng (KH):</strong> Là cá nhân, hộ kinh doanh đăng
              ký sử dụng dịch vụ của đơn vị cung cấp dịch vụ.
            </li>
            <li><strong>MB:</strong> Ngân hàng TMCP Quân đội.</li>
            <li>
              <strong>Tài khoản thanh toán (TKTT):</strong> Là tài khoản của KH
              tại MB.
            </li>
            <li>
              <strong>Dịch vụ thanh toán QR:</strong> Là dịch vụ thanh toán qua
              tài khoản làm phát sinh ghi có vào tài khoản KH đăng ký; Tomotek
              sẽ tự động tạo cho KH các mã thanh toán QR theo các thông tin của
              KH khai báo để nhận thanh toán vào tài khoản thanh toán của KH đã
              mở tại MB.
            </li>
            <li>
              <strong>Dịch vụ Loa thanh toán:</strong> Là dịch vụ thông báo biến
              động số dư bằng giọng nói kết quả giao dịch theo thời gian thực,
              giúp KH dễ dàng theo dõi kết quả giao dịch thanh toán QR thành
              công.
            </li>
            <li>
              <strong>Gói dịch vụ:</strong> Bao gồm các dịch vụ thanh toán QR và
              dịch vụ Loa thanh toán mà Tomotek cung cấp cho KH.
            </li>
            <li>
              <strong>Hủy ngang dịch vụ:</strong> Là trường hợp KH yêu cầu dừng
              gói dịch vụ trong quá trình đang sử dụng dịch vụ.
            </li>
          </ol>

          <h4>ĐIỀU 2 - NỘI DUNG DỊCH VỤ TOMOTEK CUNG CẤP</h4>
          <ol>
            <li>
              Tomotek cung cấp dịch vụ thanh toán qua QR, dịch vụ thông báo biến
              động số dư và dịch vụ loa thanh toán cho KH.
            </li>
            <li>
              Tomotek cung cấp phần cứng loa để phát ra thông báo biến động số
              dư bằng giọng nói cho KH.
            </li>
            <li>
              <strong>Phương thức hiển thị thông báo:</strong>
              <ul>
                <li>
                  Hiển thị ngay kết quả giao dịch thanh toán QR thành công trên
                  nền tảng của Tomotek (phần mềm/ứng dụng của Tomotek độc lập
                  và/hoặc miniApp của Tomotek tại MB).
                </li>
                <li>
                  Phát ra thông báo giao dịch ghi có qua QR bằng giọng nói từ
                  thiết bị loa do Tomotek cung cấp và đã kết nối cho KH thành
                  công.
                </li>
              </ul>
            </li>
            <li>
              <strong>Tần suất thông báo:</strong>
              <ul>
                <li>
                  Một lần ngay sau khi phát sinh giao dịch thanh toán chuyển
                  khoản bằng QR; và/hoặc
                </li>
                <li>
                  Theo cấu hình và yêu cầu của KH và phạm vi Tomotek đáp ứng
                  được.
                </li>
              </ul>
            </li>
          </ol>

          <h4>ĐIỀU 3 - CUNG CẤP THÔNG TIN VÀ XỬ LÝ DỮ LIỆU CÁ NHÂN</h4>
          <p>
            KH xác nhận đồng ý cung cấp thông tin của KH và thông tin của các
            giao dịch QR làm phát sinh ghi có tiền vào tài khoản của KH nhằm mục
            đích nhận diện KH, cập nhật trạng thái thành công của giao dịch trên
            nền tảng của Tomotek và/hoặc các thiết bị báo có bằng giọng nói được
            cung cấp bởi Tomotek cho KH.
          </p>

          <h4>ĐIỀU 4 - PHÍ DỊCH VỤ</h4>
          <ol>
            <li>
              Phí dịch vụ là các khoản phí KH phải trả cho Tomotek khi sử dụng
              dịch vụ mà Tomotek cung cấp.
            </li>
            <li>Phí dịch vụ được hiển thị là phí đã bao gồm VAT.</li>
            <li>
              Phí dịch vụ được thông báo và hiển thị cho KH khi đăng ký sử dụng
              dịch vụ.
            </li>
            <li>
              Phí dịch vụ sẽ không được hoàn trả cho KH trong trường hợp KH yêu
              cầu hủy ngang gói dịch vụ đã đăng ký.
            </li>
            <li>
              Biểu phí sử dụng dịch vụ do Tomotek quy định, có thể thay đổi theo
              từng thời kỳ phù hợp quy định của pháp luật và có giá trị hiệu lực
              với KH.
            </li>
            <li>
              <strong>Phương thức thu phí:</strong>
              <ul>
                <li>
                  <strong>Thanh toán phí lần đầu:</strong> Thực hiện trích nợ
                  TKTT của KH ngay thời điểm KH đăng ký dịch vụ.
                </li>
                <li>
                  <strong>Thanh toán phí gia hạn dịch vụ:</strong> Bằng việc
                  đồng ý sử dụng dịch vụ do Tomotek cung cấp, tùy thuộc vào loại
                  gói và thời gian gói dịch vụ, Tomotek áp dụng 1 khoản phí dịch
                  vụ cố định, được thu định kỳ 1 lần vào đầu kỳ. KH đồng ý về
                  việc TKTT của KH sẽ bị trích nợ để Tomotek thu phí dịch vụ và
                  đồng ý về việc thu phí này.
                </li>
              </ul>
            </li>
            <li>
              Phí chuyển phát nhanh (CPN) là phí giao thiết bị đến tay KH
              và/hoặc từ KH đến Tomotek khi phát sinh bảo hành sản phẩm.
            </li>
            <li>Phí dịch vụ chưa bao gồm phí chuyển phát nhanh cho KH.</li>
            <li>
              MB là đơn vị thực hiện thu hộ theo thỏa thuận hợp tác giữa MB và
              Tomotek. MB sẽ thực hiện thu phí KH theo chỉ định của Tomotek.
            </li>
          </ol>

          <h4>ĐIỀU 5 - THỜI HẠN CỦA GÓI DỊCH VỤ</h4>
          <ol>
            <li>
              Thời hạn Gói dịch vụ được Tomotek cung cấp bao gồm 03 tháng, 06
              tháng và 12 tháng. Thời hạn gói dịch vụ có thể được bổ sung, thay
              đổi theo chính sách Tomotek từng thời kỳ.
            </li>
            <li>
              Thời hạn của Gói dịch vụ được áp dụng tính từ ngày KH thanh toán
              thành công phí gói dịch vụ tương ứng cho tới ngày tương ứng của 03
              hoặc 06 hoặc 12 tháng kế tiếp (tùy theo gói dịch vụ KH lựa chọn
              khi đăng ký).
            </li>
            <li>
              KH có thể liên hệ với hotline của Tomotek hoặc thực hiện online
              trên nền tảng của Tomotek (nếu có) để hủy tính năng gia hạn tự
              động đối với gói dịch vụ đã đăng ký.
            </li>
          </ol>

          <h4>ĐIỀU 6 - CHẤM DỨT GÓI DỊCH VỤ</h4>
          <ol>
            <li>
              KH có thể chấm dứt sử dụng Gói dịch vụ bằng các cách sau:
              <ul>
                <li>
                  Hủy gia hạn bằng hotline hoặc tắt tính năng gia hạn gói dịch
                  vụ trên nền tảng mà Tomotek cung cấp.
                </li>
                <li>
                  KH liên hệ hotline để hủy dịch vụ ngay. Tomotek sẽ thực hiện
                  hủy dịch vụ cho KH tại thời điểm KH yêu cầu. Phí dịch vụ sẽ
                  không được hoàn trả.
                </li>
              </ul>
            </li>
          </ol>

          <h4>ĐIỀU 7 - THAY ĐỔI NỘI DUNG ĐIỀU KIỆN ĐIỀU KHOẢN</h4>
          <p>
            KH đồng ý rằng Tomotek có quyền thay đổi các điều khoản của bản Điều
            kiện Điều khoản này (“Bản điều khoản, điều kiện sửa đổi”). Tomotek
            sẽ thông báo tới KH bằng 1 trong các hình thức: (i) gửi thông báo
            bằng văn bản hoặc email hoặc SMS tới địa chỉ hoặc SĐT của KH đăng ký
            hoặc (ii) niêm yết tại website của Tomotek hoặc (iii) các hình thức
            khác do Tomotek quyết định.
          </p>

          <h4>
            ĐIỀU 8 - CHÍNH SÁCH GIAO HÀNG, ĐỔI TRẢ VÀ BẢO HÀNH PHẦN CỨNG LOA
            THANH TOÁN
          </h4>
          <ol>
            <li>
              <strong>Giao hàng:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm giao phần cứng Loa thanh toán qua đơn
                  vị chuyển phát nhanh (CPN) đến KH theo địa chỉ mà KH đã đăng
                  ký.
                </li>
                <li>
                  Trong trường hợp đơn vị CPN không thể liên hệ với KH để giao
                  hàng, đơn hàng sẽ được xem là hủy, và đơn vị CPN sẽ hoàn trả
                  sản phẩm lại cho Tomotek.
                </li>
                <li>
                  Tomotek sẽ hoàn trả lại số tiền phí dịch vụ cho KH trong vòng
                  tối đa 7 ngày làm việc, kể từ ngày Tomotek nhận được hàng hoàn
                  trả từ đơn vị CPN.
                </li>
              </ul>
            </li>
            <li>
              <strong>Bảo hành phần cứng Loa thanh toán:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm bảo hành 1 đổi 1 loa thanh toán trọn
                  đời khi KH còn sử dụng dịch vụ Loa thanh toán của Tomotek.
                </li>
                <li>
                  KH được Tomotek bảo hành 1 đổi 1 loa thanh toán trọn đời dịch
                  vụ.
                </li>
              </ul>
            </li>
            <li>
              <strong>Bảo hành từ xa:</strong>
              <ul>
                <li>
                  Tomotek có trách nhiệm trả lời hướng dẫn sửa chữa thông qua
                  Hotline của Tomotek.
                </li>
                <li>
                  KH cần liên hệ với Hotline của Tomotek khi có bất kỳ lỗi từ
                  phần cứng và phần mềm của Loa thanh toán và phối hợp theo
                  hướng dẫn đại diện chăm sóc KH trên Hotline.
                </li>
              </ul>
            </li>
            <li>
              <strong>Đổi trả:</strong>
              <ul>
                <li>
                  Khi bảo hành từ xa không khắc phục được, Tomotek sẽ gửi 1
                  thiết bị tương đương qua đơn vị chuyển phát đến KH. Phí chuyển
                  phát nhanh thiết bị được quy định như sau:
                </li>
                <li>
                  <strong>Trường hợp 1 - Đổi mới thiết bị:</strong>
                  <ul>
                    <li>
                      Khi KH nhận hàng qua CPN, KH được thực hiện mở hàng kiểm
                      tra và kết nối. Tomotek chịu toàn bộ chi phí đổi trả 2
                      chiều cho KH nếu thiết bị không hoạt động. Tomotek sẽ chịu
                      toàn bộ phí CPN đổi trả 2 chiều.
                    </li>
                    <li>
                      <strong>Điều kiện đổi trả sản phẩm:</strong>
                      <ul>
                        <li>
                          KH quay lại video clip quá trình mở kiện hàng để làm
                          bằng chứng khi có khiếu nại xảy ra (nếu KH đã nhận
                          được hàng).
                        </li>
                        <li>
                          KH quay lại video clip quá trình đóng gói sản phẩm kèm
                          đầy đủ phụ kiện, quà tặng, mút xốp, bóng khí (nếu có)
                          để đảm bảo hàng nguyên vẹn khi vận chuyển (nếu KH đã
                          nhận được hàng).
                        </li>
                        <li>
                          Sản phẩm đổi phải giữ nguyên 100% hình dạng ban đầu,
                          thân máy và màn hình sản phẩm (nếu có) không bị trầy
                          xước cong vênh.
                        </li>
                        <li>Hoàn trả lại đầy đủ hộp, sạc, phụ kiện đi kèm.</li>
                        <li>
                          Hoàn trả sản phẩm cho đơn vị vận chuyển ngay tại thời
                          điểm nhận hàng.
                        </li>
                      </ul>
                    </li>
                  </ul>
                </li>
                <li>
                  <strong>Trường hợp 2 - Đổi trả bảo hành:</strong>
                  <ul>
                    <li>
                      Trường hợp KH đã sử dụng một thời gian nhưng gặp lỗi, đã
                      liên hệ hotline bảo hành từ xa nhưng không xử lý được lỗi,
                      KH sẽ thực hiện chuyển lại thiết bị cho Tomotek bảo hành.
                      KH chịu phí CPN chiều đi. Tomotek chịu phí CPN chiều đến
                      KH.
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
          </ol>
        </main>
        <footer class="modal-footer w-100">
          <button
            class="button-secondary w-100"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            Đã hiểu
          </button>
        </footer>
      </section>
    </div>
  </div>
</div>
<div
  #modalAdd
  class="modal fade bottom-modal mw-100"
  id="modalAdd"
  tabindex="-1"
  aria-labelledby="modalAddLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="modal-content" style="border-radius: 1rem;">
      <section class="delivery-modal">
        <header class="modal-header">
          <h4 class="modal-title">Đăng ký cửa hàng</h4>
          <button
            class="close-button"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/97a7253f394325dd307cb69b66b6c2a5d4f713d8a927da55219b908ade8639d6?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
              alt=""
              class="close-icon"
            />
          </button>
        </header>
        <main class="modal-content">
          <form class="referral-form px-2" [formGroup]="orderForm">
            <div class="input-group">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/b747068bdaff285b4c0b598eae2550df6ccb62a982e33f35b7eabcab01c462e7?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="input-icon"
              />
              <mat-form-field>
                <mat-label>Tên cửa hàng</mat-label>
                <input matInput formControlName="storeName" required 
                (input)="onInputChange($event, 'storeName')"
                />
                <mat-error
                  *ngIf="
                    orderForm.get('storeName').invalid &&
                    (orderForm.get('storeName').touched ||
                      orderForm.get('storeName').dirty)
                  "
                >
                  Tên cửa hàng là bắt buộc.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-group">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/a24af1b7a5113f1d1d02150c4ec757a1d4892b18490fa41dad044b3bd0023a26?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="input-icon"
              />
              <mat-form-field>
                <mat-label>Địa chỉ cửa hàng</mat-label>
                <input matInput formControlName="storeAddress" required 
                (input)="onInputChange($event, 'storeAddress')"
                />
                <mat-error
                  *ngIf="
                    orderForm.get('storeAddress').invalid &&
                    (orderForm.get('storeAddress').touched ||
                      orderForm.get('storeAddress').dirty)
                  "
                >
                  Địa chỉ cửa hàng là bắt buộc.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="input-group">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/8795d34e354a4ea4c2f1e673f1b6b70614e105214919bea0ffb38ff3145fb12c?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="input-icon"
              />
              <mat-form-field *ngIf="dataUser.length > 0; else inputTemplate">
                <mat-label>Số tài khoản QR</mat-label>
                <mat-select
                  panelClass="customClass"
                  formControlName="qrAccount"
                  (selectionChange)="onInputBlur()"
                  required
                >
                  <mat-option [value]="">
                    Thêm mới tài khoản
                  </mat-option>
                  <mat-option
                    *ngFor="let account of dataUser"
                    [value]="account.account_number"
                  >
                    {{ account.account_number }}
                  </mat-option>
                </mat-select>
                <mat-error
                  *ngIf="
                orderForm.get('qrAccount').invalid &&
                (orderForm.get('qrAccount').touched ||
                  orderForm.get('qrAccount').dirty)
              "
                >
                  Số tài khoản QR là bắt buộc.
                </mat-error>
              </mat-form-field>
              <ng-template #inputTemplate>
                <mat-form-field>
                  <mat-label>Số tài khoản QR</mat-label>
                  <input
                    matInput
                    formControlName="qrAccount"
                    (blur)="onInputBlur()"
                    (input)="onInputChange($event, 'qrAccount')"

                    required
                  />
                  <mat-error
                    *ngIf="
                  orderForm.get('qrAccount').invalid &&
                  (orderForm.get('qrAccount').touched ||
                    orderForm.get('qrAccount').dirty)
                "
                  >
                    Số tài khoản QR là bắt buộc.
                  </mat-error>
                </mat-form-field>
              </ng-template>
            </div>
            <div class="input-group">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=0d653a5c804943d49c4f137d12fcfdcb"
                alt=""
                class="input-icon"
              />
              <mat-form-field>
                <mat-label>Chủ tài khoản</mat-label>
                <input
                  matInput
                  formControlName="accountOwner"
                  readonly
                  required
                />
                <mat-error
                  *ngIf="
                    orderForm.get('accountOwner').invalid &&
                    (orderForm.get('accountOwner').touched ||
                      orderForm.get('accountOwner').dirty)
                  "
                >
                  Chủ tài khoản là bắt buộc.
                </mat-error>
              </mat-form-field>
            </div>
          </form>
        </main>
        <footer class="modal-footer w-100">
          <button
            class="btn-viettel p-3 rounded-4 w-100"
            (click)="addWorkspace()"
            data-bs-dismiss="modal"
            [disabled]="
        orderForm.get('storeName').invalid || 
        orderForm.get('storeAddress').invalid || 
        orderForm.get('qrAccount').invalid || 
        orderForm.get('accountOwner').invalid
      "
          >
            Thêm mới
          </button>
        </footer>
      </section>
    </div>
  </div>
</div>
<div
  #chooseModal
  class="modal fade bottom-modal mw-100"
  id="chooseModal"
  tabindex="-1"
  aria-labelledby="chooseModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-bottom">
    <div class="modal-content" style="border-radius: 1rem;">
      <section class="delivery-modal">
        <header class="modal-header">
          <h2 class="modal-title">Thông tin người giới thiệu</h2>
          <button
            class="close-button"
            data-bs-dismiss="modal"
            aria-label="Close"
            aria-label="Close modal"
          >
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/97a7253f394325dd307cb69b66b6c2a5d4f713d8a927da55219b908ade8639d6?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
              alt=""
              class="close-icon"
            />
          </button>
        </header>
        <main class="modal-content">
          <form class="referral-form" [formGroup]="orderForm">
            <label class="visually-hidden"
              >Mã RM/người giới thiệu</label
            >
            <div class="input-wrapper">
              <div class="input-group">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/7bb4f99945c16a3c8e91b6a3f62fbca6b91ef06abf65b617ca4e317da6965d2f?placeholderIfAbsent=true&apiKey=d4ca2351fe0547ebb2bb09bab66a16f8"
                  alt=""
                  class="input-icon"
                />

                <mat-form-field>
                  <mat-label>Mã RM/người giới thiệu</mat-label>
                  <input matInput type="text" [(ngModel)]="referrerCode" 
                    [ngModelOptions]="{standalone: true}"
                  (input)="onInputChange($event, 'referrer')"
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="px-3">
              <button
                class="button-primary w-100 my-3"
                [disabled]="inProgress || referrerCode === ''"
                data-bs-dismiss="modal"
                (click)="processPayment()"
              >
                Tiếp tục
              </button>
              <button
                *ngIf="serviceType === 'shipper'"
                class="button-secondary w-100"
                [disabled]="inProgress"
                data-bs-dismiss="modal"
                (click)="processPayment()"
              >
                Bỏ qua
              </button>
            </div>
          </form>
        </main>
      </section>
    </div>
  </div>
</div>
